import { BehaviorSubject, Subscription, Observable } from 'rxjs';
import { Shelf } from './Shelf'
import { AngularFireDatabase } from 'angularfire2/database';
import { NgZone } from '@angular/core'
import { Utilities } from '../Utilities'

export class Library {
    public static debugMode:boolean;

    shelves:Observable<Shelf[]>
    isOwner:Observable<boolean>
    noShelves:Observable<boolean>

    constructor(private userId:string, private loggedInUserId:Observable<string>, private shelvableDb:firebase.database.Reference, private db:AngularFireDatabase, private zone:NgZone) {
        NgZone.assertInAngularZone();
        this.isOwner = loggedInUserId.map((currentUserId) => currentUserId === userId).shareReplay(1);

        this.shelves = this.isOwner.flatMap((isOwner) => {
            var shelfList:Observable<string[]>;
            if (isOwner) {
                console.log('user owns this library');
                var bookshelvesRef = shelvableDb.child('users').child(userId).child('bookshelves');
                shelfList = this.db.object(bookshelvesRef).map((obj) => obj.$exists() ? obj : {}).map(Object.keys).distinctUntilChanged(Utilities.compareArrayOfStrings).shareReplay(1);
            } else {
                console.log('user doesn\'t own this library');
                var publicShelvesRef = shelvableDb.child('users').child(userId).child('publicShelves'); 
                shelfList = this.db.object(publicShelvesRef).map((obj) => obj.$exists() ? obj : {}).map(Object.keys).distinctUntilChanged(Utilities.compareArrayOfStrings).shareReplay(1);
            }

            var shelfCache:{[shelfName:string]:Shelf} = {};

            return shelfList
            .do((shelfList) => console.log("Shelf list changed, rebuilding shelves.", shelfList))
            .map((shelfList) => shelfList.map((shelfName) => {
                if (shelfCache[shelfName]) {
                    return shelfCache[shelfName];
                } else {
                    console.log('Creating new shelf ' + shelfName);
                    var shelf = new Shelf(this.userId, shelfName, this.shelvableDb, this.loggedInUserId, this.db, this.zone);
                    shelfCache[shelfName] = shelf;
                    return shelf;
                }
            }));
        }).shareReplay(1);

        this.noShelves = this.shelves.map((shelves) => shelves.length === 0).do((n) => {if (n) console.log('no shelves')});
    }

}


// WEBPACK FOOTER //
// ./web/static/services/ShelvableBackend/Library.ts